<template>
  <div>
    <el-form
      style="height: 99%; position: absolute; width: 100%"
      :style="{ padding: pageStates == 'view' ? '20px 60px' : '' }"
      :inline="true"
      :model="entryInfo"
      :rules="pageStates == 'view' ? {} : rules"
      ref="refForm"
      label-width="130px"
      label-position="right"
      label-suffix=" ："
    >
      <el-scrollbar style="height: 100%">
        <div>
          <el-col :span="24">
            <el-form-item label="柜号" prop="cabinetNumber">
              <span v-if="pageStates == 'view'">{{
                entryInfo.cabinetNumber ? entryInfo.cabinetNumber : "暂无"
              }}</span>
              <el-input
                v-else
                v-model="entryInfo.cabinetNumber"
                clearable
                disabled
                placeholder="请输入柜号"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="数据来源">
              <span v-if="pageStates == 'view'">{{
                entryInfo.dataSource
                  ? entryInfo.dataSource == "0"
                    ? "司机预约"
                    : entryInfo.dataSource == "1"
                    ? "客服录入"
                    : "暂无"
                  : "暂无"
              }}</span>
              <el-radio-group v-model="entryInfo.dataSource" v-else disabled>
                <el-radio :label="'0'">司机预约</el-radio>
                <el-radio :label="'1'">客服录入</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="作业类型" prop="operateType">
              <span v-if="pageStates == 'view'">{{
                entryInfo.operateType == "1"
                  ? "装货"
                  : entryInfo.operateType == "2"
                  ? "卸货"
                  : entryInfo.operateType == "3"
                  ? "过车"
                  : "暂无"
              }}</span>
              <el-radio-group v-else v-model="entryInfo.operateType" disabled>
                <el-radio :label="1">装货</el-radio>
                <el-radio :label="2">卸货</el-radio>
                <el-radio :label="3">过车</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="客户名称" prop="custom">
              <span v-if="pageStates == 'view'">{{
                entryInfo.custom ? entryInfo.custom : "暂无"
              }}</span>
              <el-input
                v-else
                v-model="entryInfo.custom"
                clearable
                placeholder="请输入客户名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="司机姓名" prop="driverName">
              <span v-if="pageStates == 'view'">{{
                entryInfo.driverName ? entryInfo.driverName : "暂无"
              }}</span>
              <el-input
                v-else
                v-model="entryInfo.driverName"
                clearable
                placeholder="请输入司机姓名"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="电话" prop="phone">
              <span v-if="pageStates == 'view'">{{
                entryInfo.phone ? entryInfo.phone : "暂无"
              }}</span>
              <el-input
                v-else
                v-model="entryInfo.phone"
                clearable
                placeholder="请输入电话"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="前车车牌" prop="frontPlate">
              <span v-if="pageStates == 'view'">{{
                entryInfo.frontPlate ? entryInfo.frontPlate : "暂无"
              }}</span>
              <el-input
                v-else
                v-model="entryInfo.frontPlate"
                clearable
                placeholder="请输入前车车牌"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item
              label="操作类型"
              prop="passType"
              v-if="entryInfo.operateType == '3'"
            >
              <span v-if="pageStates == 'view'">{{
                entryInfo.passType == "1"
                  ? "倒入"
                  : entryInfo.passType == "2"
                  ? "倒出"
                  : "暂无"
              }}</span>
              <el-radio-group v-else v-model="entryInfo.passType" disabled>
                <el-radio :label="1">倒入</el-radio>
                <el-radio :label="2">倒出</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="货品名称" prop="waresName">
              <span v-if="pageStates == 'view'">{{
                entryInfo.waresName ? entryInfo.waresName : "暂无"
              }}</span>
              <el-input
                v-else
                clearable
                v-model="entryInfo.waresName"
                placeholder="请输入货品名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="数量" prop="waresCount">
              <span v-if="pageStates == 'view'">{{
                entryInfo.waresCount ? entryInfo.waresCount : "暂无"
              }}</span>
              <el-input
                v-else
                clearable
                v-model="entryInfo.waresCount"
                placeholder="请输入数量"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="重量" prop="waresWeight">
              <span v-if="pageStates == 'view'">{{
                entryInfo.waresWeight ? entryInfo.waresWeight : "暂无"
              }}</span>
              <el-input
                v-else
                clearable
                v-model="entryInfo.waresWeight"
                placeholder="请输入重量"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="预约到达时间" prop="estimatedArrivalTime">
              <span v-if="pageStates == 'view'">{{
                entryInfo.estimatedArrivalTime
                  ? entryInfo.estimatedArrivalTime
                  : "暂无"
              }}</span>
              <el-date-picker
                v-else
                clearable
                v-model="entryInfo.estimatedArrivalTime"
                type="date"
                placeholder="请选择日期"
                style="width: 100%"
                format="yyyy/MM/dd"
                value-format="yyyy/MM/dd"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </div>
      </el-scrollbar>
    </el-form>
  </div>
</template>

<script>
import { api } from "../api";
import sha256 from "@src/common/lib/sha";
import utils from "@src/common/utils";

const resetForm = () => {
  return {
    appointmentUuid: "", // uuid
    appointmentCabinetCode: "", // code
    appointmentStatus: "", // status
    cabinetNumber: "", // 柜号 不允许修改
    dataSource: "", // 数据来源
    custom: "", // 客户名称
    driverName: "", // 司机姓名
    estimatedArrivalTime: "", // 预约到达时间
    frontPlate: "", // 车牌号
    operateType: null, // 操作类型 不允许修改
    passType: null, // 作业类型 不允许修改
    phone: "", // 电话
    waresCount: "", // 数量
    waresName: "", // 货品名称
    waresWeight: "", // 重量
  };
};
export default {
  props: {
    pageStates: {
      type: String,
      default: "edit",
    },
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      var reg = new RegExp("^1[3456789]\\d{9}$");
      if (!reg.test(value)) {
        callback(new Error("手机号码格式不正确"));
      } else {
        callback();
      }
    };
    const validateNumber = (rule, value, callback) => {
      var reg = new RegExp("^[0-9]+$");
      if (!reg.test(value)) {
        callback(new Error("格式不正确"));
      } else {
        callback();
      }
    };
    return {
      entryInfo: resetForm(),
      rules: {
        estimatedArrivalTime: [
          {
            required: true,
            message: "请选择预约到达时间",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  mounted() {
    this.parkType = [utils.Cache.get("CACHE_USER_INFO").parkInfoTree];
  },
  methods: {
    handleSetForm(info) {
      this.entryInfo = {
        ...info,
      };
      // 预约时间单独赋值
      if (this.entryInfo.estimatedArrivalTime) {
        this.entryInfo.estimatedArrivalTime =
          this.entryInfo.estimatedArrivalTime.replaceAll("-", "/");
      }
      this.$refs.refForm.clearValidate();
    },
    handleRestForm() {
      this.entryInfo = resetForm();
      // this.$refs.refForm.resetFields();
      this.$nextTick(() => {
        this.$refs["refForm"].clearValidate();
      });
    },

    submit() {
      this.$refs.refForm.validate((res) => {
        if (res) {
          let params = { ...this.entryInfo };
          console.log("-this.entryInfo:-", this.entryInfo.entryDate);
          // 修改成功 需要刷新列表界面
          // 关闭详情界面 需要刷新列表界面
          if (this.pageStates == "view") {
            this.$emit("save-entry-info", params);
          } else {
            // 调用文本录入接口 拼接请求参数 cabinetNumber, waresCount, waresName, waresWeight
            params.vehicleCabinets = [
              {
                cabinetNumber: this.entryInfo.cabinetNumber,
                waresCount: this.entryInfo.waresCount,
                waresName: this.entryInfo.waresName,
                waresWeight: this.entryInfo.waresWeight,
              },
            ];
            this.$fetch(api.import.updateCustomerImportData, params).then(
              (response) => {
                if (response && response.success) {
                  this.$message({
                    message: "修改成功",
                    type: "success",
                    duration: 2000,
                  });
                  this.$emit("save-entry-info", params);
                } else {
                  this.$message({
                    message: response.msgContent,
                    type: "error",
                    duration: 2000,
                  });
                }
              }
            );
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
:deep .el-upload--picture-card {
  width: 85%;
  margin: 5px 0px 0;
  height: 175px;
  line-height: 175px;
}

.el-form-item {
  width: 100%;
  display: flex;

  :deep .el-form-item__content {
    width: calc(100% - 135px);
  }

  :deep .el-upload--picture-card {
    width: 180px;
    height: 175px;
    // background: #0d121c;
  }

  .el-input__inner {
    width: 100%;
  }
}

.imgFile {
  // display: flex;
  // width: 148px;
  height: 185px;
  position: relative;

  .viewImg {
    width: 180px;
    height: 175px;
    cursor: pointer;
  }

  .uploadImg {
    margin: 5px 0;
    width: 180px;
    height: 175px;
    cursor: pointer;
  }

  &:hover {
    .delete-icon {
      opacity: 1;
    }
  }

  .delete-icon {
    font-size: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 3px;
    left: 0;
    width: 180px;
    height: 177px;
    border-radius: 6px;
    opacity: 0;
    cursor: pointer;
    background-color: rgba($color: #000000, $alpha: 0.4);
    transition: all 0.2s;
    box-shadow: -1px -1px 5px #7367f0, 1px 1px 5px #7367f0;
  }
}
</style>
